import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

  *, ::after, ::before {
    box-sizing: border-box;
  }

  html {
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: transparent;
    direction: ${({ dir }) => dir};

    font-family: ${(props) =>
      props.dir === 'rtl' ? 'GESSTwoDWTCLight, DINRegular, sans-serif ' : 'DINRegular '};
    [dir="rtl"] * {
      letter-spacing: 0 !important;
    }
    &[lang=en] {

      input[type=checkbox] {
        margin-right: 6px;
      }

      h2,
      h3 {
        font-family: 'LibreBaskervilleRegular' ;
      }

      .sub2 {
        font-family:'DINRegular' ;
        font-size: 12px;
        line-height: 16px;
      }

      body {
        &.is-event {
          li:has(a[title*="Events"]) {
            background: #1b7bdd;
          }
        }
        &.about-page{
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
        &.is-article {
          li:has(a[title*="Events"]) {
            background: #1b7bdd;
          }
          .date_time{
            text-transform: inherit;
          }
        }
        &.is-insights {
          li:has(a[title*="Events"]) {
            background: #1b7bdd;
          }
        }
        &.insights-page, &.insight_lang {
          .ins_lang, .mbl_lang{
            display:none;
          }
        }
        strong {
          font-family: 'DINMedium' ;
        }
        .Form {

          .Form-column {

            &:last-child {
              p {
                @media (min-width: 768px) {
                  text-align: right;
                }
              }
            }
          }

          p {

            @media (min-width: 992px) {
              letter-spacing: 1.82px;
            }

            @media (max-width: 991px) {
              letter-spacing: 1.62px;
            }
          }

          button {
            letter-spacing: 1.82px;
          }
        }
      }
    }

    &[lang=ar] {
      text-align: right;

      .gm-style {
        .gm-style-iw-c {
              padding-right: 10px!important;
          font-family: GESSTwoDWTCLight, DINLight, sans-serif ;
          a {
            font-size: 12px;
          }
        }
        .gm-style-iw-d{
          direction: rtl;
        }
      }

      input[type=checkbox] {
        margin-left: 6px;
      }
      
      h2 {
        font-family: GEAwtarDWTCMedium, DINRegular, serif!important;
      }

      h3 {
        font-family: GESSTwoDWTCMedium, DINMedium, serif!important;
      }
      a{
        font-family: GESSTwoDWTCMedium, DINMedium, sans-serif!important;
      }

      .sub2 {
        font-family: GESSTwoDWTCLight, DINRegular, sans-serif ;
        font-size: 14px;
        line-height: 20px;
      }

      .hline {
        &:before {
          margin-right: auto;
          margin-left: 15px;
        }
      }

      body {
        &.is-article {
          li:has(.primary_menu) {
            &:nth-child(1){
              background: #1b7bdd;
            }
          }
        }
        &:not(.free-zone) {
          strong {
            font-family: GESSTwoDWTCMedium, DINMedium, sans-serif!important;
          }
          p{
            font-family: GESSTwoDWTCLight, DINRegular, sans-serif!important;
          }
        }
        h2 {
          strong {
            font-weight: bold;
            font-family: inherit!important;
          }
        }
        .Form {
          .Form-column {
            font-family: inherit;

            input[type=date],
            input[type=password],
            input[type=text],
            select, 
            textarea {
              font-family: inherit;
              letter-spacing: 0;
            }

            label {
              letter-spacing: 0;
            }
            &:last-child {
              p {
                @media (min-width: 768px) {
                  text-align: left;
                }
              }
            }
          }
        }
      }
       &[dir='rtl'] .slick-prev:before {
         transform: rotate(135deg);
      }
       &[dir='rtl'] .slick-next:before {
         transform: rotate(315deg);
       }
       /* &[dir='rtl'] {
        .slick-slide {
           float: left;
         }
       } */

    }

    body {
      p {
        margin-bottom: 1.5rem;
      }
      .Form {

        p {
          font-size: 10px;
          margin-bottom: 1rem;
        }

        .Form-fieldset {
          column-gap: 0!important;
          margin: 0 -15px;
          padding: 0;
        }

        .Form-fieldGroup {

          span:last-child {
            font-size: 12px;
            padding-top: 5px;
            color: #dc3545;
            display: block;
          }

        }

        .Form-column {
          padding: 0 15px;

          &[data-columns='6'] {
            @media (max-width: 767px) {
              grid-column: 1 / -1 !important;
            }
          }
        }

        button {
          margin: 0;
          cursor: pointer;
          display: inline-block;
          white-space: nowrap;
          vertical-align: middle;
          user-select: none;
          border: 1px solid transparent;
          line-height: 1.5;
          font-family: inherit;
          font-size: 12px;
          border-radius: 20px;

          padding: 10px 1.5rem;
          min-width: 215px;
          text-align: center;
          text-transform: uppercase;
          background-color: #1b7bdd;
          color: #fff;
          transition: .3s;

          &:hover {
            background-color: #165ca3;
          }
        }
      }

      .Form-fieldGroup {
        p {
          font-size: 10px;

          a {
            color: #1b7bdd;
            text-decoration: underline;
          }
        }
      }

      .slick-dots {
        left: 0;
        bottom: 0;
        position: relative;
        padding-top: 40px;

        li {
          margin: 0;
          background: none;

          button {
            padding: 0;
            margin: 5px;
            width: 10px;
            height: 10px;
            position: relative;
            transition: .3s;
            @media(max-width:767px){width:7px;height:7px;}

            &:before {
              content: '';
              opacity: 1;
              width: 100%;
              height: 100%;
              background-color: #9b9b9b;
              display: block;
              margin: 0;
              border-radius: 100%;
            }
            &:focus{outline:none!important;border:none;}
          }

          &.slick-active {
            button {
              margin: 3px;
              width: 15px;
              height: 15px;
              @media(max-width:767.98px){width: 12px;height: 12px;}

              &:before {
                width: 100%;
                height: 100%;
                opacity: 1;
                margin: 0;
              }
            }
          }
        }
      }
      .slick-slider{
        .slick-arrow{
            &:focus{outline:none!important;}
          }
      }
    }
  }

  body {

    #noBgId {
      max-width: 1190px;
      margin-left: auto;
      margin-right: auto;

      @media (min-width: 768px) {
        padding-bottom: 50px;
      }
    }

    #faqsSearchBar {
      position: relative;
      z-index: 91;
    }
    .fullscreen-iframe {
      position:absolute; left: 0; right: 0; bottom: 0; top: 0px;
    }
    .explor-frame {
      border: 0px;
      width: 100%;
      overflow: hidden;
      margin-top: 50px;

      @media (min-width: 768px) {
        height: 686px;
      }

      @media (max-width: 767px) {
        height: 300px;
      }

      & + .promo-banner {
        margin-top: 20px;
      }
    }

    @media(min-width: 992px) {
      .innerContent {
        div[class*='SocialMediaFloatingButtonsstyled__ShareIconWrapper-'] {
          top: 9.75rem;
        }
      }
      
      .bellowBanner {
        div[class*='SocialMediaFloatingButtonsstyled__ShareIconWrapper-'] {
          top: 1.8rem;
        }
      }
    }

    .no_padding {
      div[id="padding_bar"] {
        display: none;
      }
    }

    .slick-slide {
      overflow: hidden;

      & > div {
        display: flex;
        min-height: 100%;
      }
    }
    .width_100{width:100%;}
    .slick-next,
    .slick-prev {
      width: 50px;
      height: 50px;

      &:before {
        border: solid #9b9b9b;
        border-width: 0 4px 4px 0;
        padding: 0;
        display: inline-block;
        color: transparent;
        @media(max-width:767.98px){
          font-size: 16px;
        }
      }
    }

    .slick-next {
      right: -50px;
      left:${({ dir }) => (dir === 'rtl' ? 'auto!important' : '')};

      &:before {
        transform: rotate(-45deg);
      }

      @media (max-width: 1199px) {
        right: -45px;
      }
    }

    .slick-prev {
      left: -50px;

      &:before {
        transform: rotate(135deg);
      }
    }
  }

  img {
    opacity: 1;
    filter: alpha(opacity=100);
    transition: opacity .2s;
    display: block;
    max-width: 100%;
    height: auto;
    border-style: none;
  }

  a {
    text-decoration: none;
    background-color: transparent;
    transition: .3s;
    color: #000;
  }

  p {
    margin-top: 0;
    margin-bottom: 1rem;
    color: #898989;
  }

  .p-0 {
    padding: 0!important;
  }

  time {
    text-transform: uppercase;
  }

  h2 {
    font-size: 30px;
    font-weight: 400;
    line-height: 50px;
    margin: 0 0 1.5rem;

    @media (max-width: 1399px) {
      line-height: 40px;
    }
    @media (max-width: 1199px) {
      font-size: 26px;
      line-height: 30px;
    }
  }

  h3 {
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    margin: 0 0 1.5rem;
  }

  input:focus,
  textarea:focus,
  select:focus {
    outline-color: transparent;
  }

  body {
    padding: 0;
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    overflow: auto;
    color: #000;
    background-color: #fff;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .content {
    position: relative;
    z-index: 2;
  }

  .caption {
    position: relative;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0,0,0,0);
    white-space: nowrap;
    clip-path: inset(50%);
    border: 0;
  }

  .sb-icon-search {
    background-color: #000;
    z-index: 90;
  }

  .sb-search-submit {
    opacity: 0;
    color: transparent;
    border: none;
    z-index: -1;
  }

  .sb-search-input {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    background: #fff;
    width: 100%;
    height: 50px;
    margin: 0;
    z-index: 10;
    line-height: 1;
    padding: ${({ dir }) => (dir === 'rtl' ? '18px 20px 18px 65px' : '18px 65px 18px 20px')};
    font-family: inherit;
    font-size: 13px;
    color: #333;
  }

  .hline {
    position: relative;
    display: block;

    &:before {
      content: '';
      position: relative;
      display: inline-block;
      width: 100px;
      height: 1px;
      background-color: #fff;
      vertical-align: middle;
      margin-right: 15px;

      @media (max-width: 1199px) {
        width: 50px;
      }
    }
  }

  @keyframes bounce{
    0%,100%,20%,50%,80% {
      transform:translateY(0)
    }
    40%{
      transform:translateY(-30px)
    }
    60%{
      transform:translateY(-15px)
    }
  }

  .bounce {
    -moz-animation: bounce 3s infinite;
    -webkit-animation: bounce 3s infinite;
    animation: bounce 3s infinite;
  }

  .scr-down {
    position: absolute;
    bottom: 25px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 50px;
    height: 50px;
    background: none;
    border: 0;
    cursor: pointer;
    z-index: 9;

    @media (max-width: 991px) {
      display: none;
    }

    span {
      margin: 30px 17px 0;
      transform: rotate(45deg);
      width: 10px;
      height: 10px;
      border: solid #fff;
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
    }
  }
  .venue-inner-page{
    .banner_stats{
      @media (max-width:797.98px){
        margin-top: 0px;
      }
    }
    .secondary-page-nav{
      .toggleBtn{
        span{
          @media (max-width:797.98px){
            background: #fff;
          }
        }
      }
      .logo{
        .dwtclogo{
          @media (max-width:797.98px){
            background-image: url(/svg/dwtc-logo-white-v2.svg)!important;
          }
        }
      }
    }
  }
  .event_detailswrapper, .insights_details{
    .insightshome_slider{
      margin-bottom:-50px;
    }
  }
  .smoothed {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

`;
